import { DIMBO_CONSTANT } from './../../utils/constant';
import { CacheService } from './../../services/cache.service';
import { CommonService } from './../../services/common.service';
import { Observable } from 'rxjs';
import { AuthenticationService } from './../../services/authentication.service';
import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');
@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {
  title = 'dmbr-ui';
  selectedTab = 0;
  newtabdata = {};
  tabs;
  tranlabel;
  selected = new FormControl(0);
  isTokenValidated: boolean = false;
  isErrorDetected: boolean = false;
  reloadFirstTab: boolean = false;
  isVehicleInfoUpdated: boolean;
  isAdditionalInfoUpdated: boolean;
  isMaintenanceTabSelected: boolean;
  isShTabSelected: boolean;
  shscrolledcount: number;
  mTab: any;
  shTab: any;
  sheTab: any;

  constructor(
    private cacheService: CacheService,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private translationService: TranslateService,
    private authenticationService: AuthenticationService,
    @Inject(DOCUMENT) private document: Document,
    private spinner: NgxSpinnerService
  ) {
    translationService.setDefaultLang('en');
    this.shscrolledcount = 0;
    //  this.translationService.use('en');
  }
  public changeLanguage(langCode: string) {
    this.translationService.use(langCode);
  }
  ngOnInit() {
    this.translationService.setDefaultLang('en');
    this.isMaintenanceTabSelected = false;
    this.spinner.show();
    const token = window.location.href.replace(/^.*[&?]token=/, '').replace(/&.*$/, '');
    // console.log('before call token: ' );
    this.authenticationService.validateToken(token).then((result: any) => {
      this.changeLanguage(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE));
      this.tabs = ['Service History', 'Maintenance Schedule & Current Service'];
      this.translationService.get(['dimbo.i18n.MS.tab', 'dimbo.i18n.SH.tab', 'dimbo.i18n.SHE.tab'])
        .subscribe(translations => {
          this.mTab = translations['dimbo.i18n.MS.tab'];
          this.shTab = translations['dimbo.i18n.SH.tab'];
          this.sheTab = translations['dimbo.i18n.SHE.tab'];
          this.tranlabel = [this.shTab, this.mTab, this.sheTab];
          //  console.log('tranlabel: ',this.tranlabel );
          this.localeInitializer(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE)).then(() => {
            console.log('localeInitializer: done');
            this.isTokenValidated = true;
          }).catch(e => {
            console.log(e);
          });

         
        }, (error: any) => {
          this.translationService.use('en');
          this.translationService.get(['dimbo.i18n.MS.tab', 'dimbo.i18n.SH.tab', 'dimbo.i18n.SHE.tab'])
            .subscribe(translations => {
              this.mTab = translations['dimbo.i18n.MS.tab'];
              this.shTab = translations['dimbo.i18n.SH.tab'];
              this.sheTab = translations['dimbo.i18n.SHE.tab'];
              this.tranlabel = [this.shTab, this.mTab, this.sheTab];
              //  console.log('tranlabel: ',this.tranlabel );
              this.localeInitializer('en').then(() => {
                console.log('localeInitializer: done');
                this.isTokenValidated = true;
              }).catch(e => {
                console.log(e);
              });

             
            });
        });
      //   console.log('got  token: ' );
      this.spinner.hide();
    },
      (error: any) => {
        // console.log('err--> :', error);
        this.isErrorDetected = true;
        localStorage.clear();
        this.spinner.hide();
      }
    );

  }
  localeInitializer(localeId: string): Promise<any> {
    return import(
      /* webpackInclude: /\.js$/ */
      `@angular/common/locales/${localeId}.js`
    ).then(module => registerLocaleData(module.default)
    );
  }

  selectTab(event) {
    this.selectedTab = event.index;
  }

  onSwitchToFirst($event) {
    // console.log('onSwitchToFirst: ', $event);
    // console.log('selectedTab: ', this.selectedTab);
    this.reloadFirstTab = true;
    this.selected.setValue(0);
  }
  reloadServiceHistory($event) {
    //  console.log('reloadServiceHistory: ', $event);
    this.reloadFirstTab = false;
  }

  addTab(selectAfterAdding: boolean) {
    this.tabs.push('New');

    if (selectAfterAdding) {
      this.selected.setValue(this.tabs.length - 1);
    }
  }

  removeTab(event: any) {
    const index = this.tabs.indexOf('Edit Service History', 0);
    if (this.tabs.length == 3) {
      this.tabs.splice(index, 1);
    }
    this.selected.setValue(0);
  }

  onAddNewTab(event: any) {
    // console.log('onAddNewTab: ', event);
    this.newtabdata = event;
    if (this.tabs.length < 3) {
      this.tabs.push('Edit Service History');
      this.selected.setValue(this.tabs.length - 1);
    } else {
      //  console.log('Please close the edit tab first!');
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.SH.shEdit.error'), this.translationService.instant('dimbo.i18n.message.toastr.warning'));
      this.selected.setValue(0);
    }


  }

  onVeichleUpdate(event: any) {
    //  console.log('onVeichleUpdate: ', event);  
    this.isVehicleInfoUpdated = true;
  }

  onMaintenanceReload(event: any) {
    //  console.log('onMaintenanceReload: ', event);  
    this.isVehicleInfoUpdated = false;
  }

  onAdditionInfoUpdated(event: any) {
    //  console.log('onAdditionInfoUpdated: ', event);
    this.isAdditionalInfoUpdated = true;
  }

  onTabChange(event: any) {
    //  console.log('onTabChange event: ', event);
    if (event.index === 0) {
      this.isMaintenanceTabSelected = false;
      this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CREATE_SERVICE_SCOPE, false);
      this.isShTabSelected = true;
    } else if (event.index === 1) {
      this.isMaintenanceTabSelected = true;
      this.isShTabSelected = false;
    } else {
      this.isShTabSelected = false;
    }
  }
  shScrolled(event: any) {
    //  console.log('shScrolled event: ', event.count);
    this.shscrolledcount = event.count;
    this.cacheService.setItem(DIMBO_CONSTANT.CACHE_SH_SCROLL_COUNT, this.shscrolledcount);
  }

}
